/*
 * Copyright © 2026 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement } from "react"
import { BookingView } from "../stores/booking-ui-store"
import bookingCopy from "../bookingCopy"
import { bookingColors } from "../booking-theme"

// The QA reorder (D1): consent BEFORE health data. This is the implemented order,
// which deliberately swaps the PDF's Health/Consent steps.
const STEPS: Array<{ key: BookingView; label: string }> = [
  { key: "patient", label: bookingCopy.stepper.patient },
  { key: "consent", label: bookingCopy.stepper.consent },
  { key: "health", label: bookingCopy.stepper.health },
  { key: "time", label: bookingCopy.stepper.time },
]

const BookingStepper = ({ current }: { current: BookingView }): ReactElement => {
  const activeIndex = STEPS.findIndex((step) => step.key === current)
  return (
    // 2×2 pill grid below `sm` (four pills at min-content overflow a 320px viewport),
    // the original single row from `sm` up.
    <ol className="grid grid-cols-2 gap-2 sm:flex">
      {STEPS.map((step, index) => {
        const active = index === activeIndex
        const done = index < activeIndex
        const textClass = active || done ? "text-white" : "text-gray-500"
        let background = bookingColors.surfaceMuted
        if (active) {
          background = bookingColors.primary
        } else if (done) {
          background = bookingColors.primaryMuted
        }
        return (
          <li
            key={step.key}
            aria-current={active ? "step" : undefined}
            className={`flex-1 text-center rounded-md py-2 text-sm font-medium ${textClass}`}
            style={{ backgroundColor: background }}
          >
            {step.label}
          </li>
        )
      })}
    </ol>
  )
}

export default BookingStepper
